import { Banner } from "../../component/Banner"
import { GameHot } from "./GameHot"
import { TinhNang } from "./TinhNang"
import './TrangChuLayout.scss'
function TrangChuLayout () {
  return (
    <div className="home_box">
      <Banner />
      <GameHot/>
      <TinhNang/>
    </div>
  )
}

export default TrangChuLayout
